angular.module('businessThread')
    .component('businessThreadTimelineList', {
        bindings: {
            items: '<',
            loading: '<',
            emptyText: '<',
            onResourceOpen: '&',
            onUnlink: '&',
            onFlag: '&'
        },
        templateUrl: 'app/business-thread/timeline-list.html',
        controller: function (BusinessThreadTimelineUi, BusinessThreadLinkFlagService) {
            this.flags = BusinessThreadLinkFlagService.flags
            this.resourceLabel = BusinessThreadTimelineUi.resourceLabel
            this.resourceIcon = BusinessThreadTimelineUi.resourceIcon
            this.canOpen = BusinessThreadTimelineUi.canOpen
            this.resourceHref = BusinessThreadTimelineUi.resourceHref
            this.hasDetails = BusinessThreadTimelineUi.hasDetails
            this.detailClass = BusinessThreadTimelineUi.detailClass
            this.detailIcon = BusinessThreadTimelineUi.detailIcon
            this.auditUserTooltip = BusinessThreadTimelineUi.auditUserTooltip
            this.unlink = item => this.onUnlink ? this.onUnlink({item: item}) : null
            this.toggleFlag = (item, flag) => this.onFlag ? this.onFlag({item: item, flag: flag}) : null
            this.itemTrackKey = item => item ? [item.id, BusinessThreadLinkFlagService.value(item) || 'none'].join(':') : ''
            this.onResourceClick = event => {
                if (event && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
                    return
                }
                if (this.onResourceOpen) {
                    this.onResourceOpen({event: event})
                }
            }
        }
    })
